module.exports = __webpack_public_path__ + "img/waterLegendIncident.823a5e2c.svg";